import React from "react";

export function AppStoreRating() {
  return (
    <div className="mt-6 bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl border border-gray-200 shadow-md">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <div className="flex mb-2 animate-pulse">
            {[...Array(5)].map((_, i) => (
              <svg
                key={i}
                className="w-7 h-7 text-green-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>
          <div className="flex items-baseline">
            <span className="text-4xl font-bold text-gray-800">4.8</span>
            <span className="text-sm text-gray-500 ml-2">out of 5</span>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <img
            src="/apple_logo.svg"
            alt="Apple"
            className="h-12 mb-2 drop-shadow-md"
          />
          <span className="text-lg font-medium text-gray-700">App Store</span>
        </div>
      </div>
    </div>
  );
}
